import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Lock } from 'lucide-react';

export default function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/admin');
    } catch (err) {
      const detail = err.response?.data?.detail;
      if (typeof detail === 'string') setError(detail);
      else if (Array.isArray(detail)) setError(detail.map(e => e.msg || JSON.stringify(e)).join(' '));
      else setError('Login failed. Please check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-[70vh] flex items-center justify-center py-20">
      <div className="w-full max-w-sm px-6">
        <div className="text-center mb-8">
          <div className="w-14 h-14 bg-[#7AC943]/10 rounded-full flex items-center justify-center mx-auto mb-4">
            <Lock size={24} className="text-[#7AC943]" />
          </div>
          <h1 data-testid="admin-login-heading" className="font-heading text-2xl text-[#3D3D3D]">Admin Login</h1>
          <p className="text-gray-500 text-sm mt-2">Sign in to manage the gallery</p>
        </div>

        <form onSubmit={handleSubmit} data-testid="admin-login-form" className="space-y-4">
          {error && (
            <div data-testid="login-error" className="bg-red-50 text-red-600 text-sm p-3 rounded-sm border border-red-200">
              {error}
            </div>
          )}

          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input
              id="email"
              type="email"
              data-testid="login-email-input"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              placeholder="admin@example.com"
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="password">Password</Label>
            <Input
              id="password"
              type="password"
              data-testid="login-password-input"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              placeholder="Enter password"
            />
          </div>

          <Button
            type="submit"
            data-testid="login-submit-button"
            disabled={loading}
            className="w-full bg-[#7AC943] text-black hover:bg-[#68B038] font-semibold uppercase tracking-[0.1em] text-sm"
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </Button>
        </form>
      </div>
    </main>
  );
}
